import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const PremiumIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11.9806 12.9217C11.5082 12.9217 11.122 13.3646 11.122 13.915H12.8391C12.8391 13.3689 12.4529 12.9217 11.9806 12.9217Z'
        fill={color}
      />
      <path
        d='M21.6581 10.7633C22.3277 10.0796 21.958 8.88853 21.0337 8.75093L16.0799 7.99844C15.7102 7.94254 15.3939 7.70174 15.2296 7.35345L13.0114 2.65789C12.5965 1.7807 11.4012 1.7807 10.9863 2.65789L8.77226 7.34915C8.60795 7.69744 8.29166 7.93824 7.92197 7.99414L2.96808 8.74663C2.04385 8.88853 1.67005 10.0753 2.34371 10.759L5.92973 14.414C6.19673 14.6849 6.31586 15.0762 6.25424 15.4589L5.40806 20.6188C5.24786 21.582 6.21727 22.3173 7.04703 21.8615L11.4792 19.4277C11.8078 19.2471 12.2022 19.2471 12.5308 19.4277L16.963 21.8615C17.7928 22.3173 18.7581 21.582 18.602 20.6188L17.7558 15.4589C17.6942 15.0762 17.8133 14.6849 18.0803 14.414L21.6663 10.759L21.6581 10.7633ZM8.93246 11.5975C8.58331 11.5975 8.30398 11.3008 8.30398 10.9396C8.30398 10.5784 8.58741 10.2817 8.93246 10.2817C9.27751 10.2817 9.56094 10.5784 9.56094 10.9396C9.56094 11.3008 9.27751 11.5975 8.93246 11.5975ZM14.0342 12.608C13.874 13.7518 13.0155 14.6204 11.9804 14.6204C10.9452 14.6204 10.0908 13.7475 9.92652 12.608C9.89777 12.4059 10.0415 12.2167 10.2387 12.2167H13.722C13.9192 12.2167 14.063 12.4016 14.0342 12.608ZM15.0324 11.5975C14.6832 11.5975 14.4039 11.3008 14.4039 10.9396C14.4039 10.5784 14.6873 10.2817 15.0324 10.2817C15.3774 10.2817 15.6609 10.5784 15.6609 10.9396C15.6609 11.3008 15.3774 11.5975 15.0324 11.5975Z'
        fill={color}
      />
    </svg>
  )
})

PremiumIcon.displayName = 'PremiumIcon'
